<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
// testimonial slider
 $(document).ready(function () {
    var $carousel = $('.testimonial-carousel');

    $carousel.slick({
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 800,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });

    $('.arrow.prev').click(function () {
      $carousel.slick('slickPrev');
    });

    $('.arrow.next').click(function () {
      $carousel.slick('slickNext');
    });
  });


  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.features-slider', {
      slidesPerView: 1,
      spaceBetween: 20,
        loop: true, 
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  });


document.querySelectorAll('.faq-question').forEach(button => {
  button.addEventListener('click', () => {
    const answer = button.nextElementSibling;
    const expanded = button.getAttribute('aria-expanded') === 'true';

    // Close all open answers except this one (optional)
    document.querySelectorAll('.faq-question').forEach(btn => {
      if (btn !== button) {
        btn.setAttribute('aria-expanded', 'false');
        btn.querySelector('.arrow').classList.remove('down');
        btn.querySelector('.arrow').classList.add('right');
        const ans = btn.nextElementSibling;
        ans.style.maxHeight = '0';  // animate closing
        ans.classList.remove('open');
        ans.setAttribute('aria-hidden', 'true');
      }
    });

    if (expanded) {
      button.setAttribute('aria-expanded', 'false');
      button.querySelector('.arrow').classList.remove('down');
      button.querySelector('.arrow').classList.add('right');
      answer.style.maxHeight = '0';  // animate closing
      answer.classList.remove('open');
      answer.setAttribute('aria-hidden', 'true');
    } else {
      button.setAttribute('aria-expanded', 'true');
      button.querySelector('.arrow').classList.remove('right');
      button.querySelector('.arrow').classList.add('down');
      answer.style.maxHeight = answer.scrollHeight + 30 + "px";  // animate opening
      answer.classList.add('open');
      answer.setAttribute('aria-hidden', 'false');
    }
  });
});



document.addEventListener("DOMContentLoaded", function () {
  const selectors = [
    '.section-block-template--19707154333945__instagram_Bky3nT a',
    '.section-block-template--19700214399225__instagram_GP4GT7 a'
  ];

  selectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      el.setAttribute('target', '_blank');
    });
  });
});
